// @ts-check
import React from "react"
import Chip from "../atoms/misc/Chip.atom"
import { clsx } from "../../utils/strings.utils"

/** @type {React.FC<import('./InputPlaceholderChipTemplate.molecule.types').InputPlaceholderChipTemplateProps>} */
const InputPlaceholderChipTemplate = ({
  className = "",
  readOnly,
  error,
  label,
  highlighted,
  disabled,
  selected,
  ...props
}) => {
  return (
    <Chip
      className={clsx(
        "input-placeholder-chip",
        readOnly && "readonly",
        selected && "selected",
        highlighted && "highlighted",
        error && "error",
        disabled && "disabled",
        className
      )}
      template={
        <span className="p-chip-text">
          <span className="flex gap-1 align-items-center">{label}</span>
        </span>
      }
      {...props}
    />
  )
}

export default InputPlaceholderChipTemplate
